/** @jsx jsx */
import { jsx } from "theme-ui";
import PropTypes from "prop-types";

import { useCallback, useMemo, useState } from "react";

import { ActionButton, Stack } from "office-ui-fabric-react";
import useMyBoolean from "sites-common/hooks/useMyBoolean";
import { colorShades } from "sites-common/utils/fabricStyles";
import { validateConstraints } from "sites-common/utils/checkRestrictions";
import RenderSearchResult from "./RenderSearchResult";
import EMISearchBox from "./EMISearchBox";

const AbhyasiEMISearchBox = ({
  searchModes,
  renderSelectBtn,
  showClearBtn,
  restrictions,
  searchLabel,
  isPreceptorSearch,
}) => {
  const [fetched, setFetched] = useState({});
  const [vers, setVers] = useState(0);
  const [bulkOne, { toggle: toggleOne }] = useMyBoolean(
    (searchModes[0] || "basic") === "bulk"
  );
  const [advanced, { toggle: toggleAdvanced }] = useMyBoolean(
    (searchModes[0] || "basic") === "advanced"
  );

  const filters = useMemo(() => {
    const ret = {};
    if (restrictions) {
      const c = validateConstraints(
        [{ conds: restrictions, msg: "Preceptor" }],
        { record_type: "t" }
      );
      if (c.length === 0) {
        ret.is_prefect = 1;
      }
    }
    return ret;
  }, [restrictions]);

  const onNewValue = useCallback(
    (v, skey) => {
      // Commented the below code for addressing MEM-237
      // if (restrictions) {
      //   const c = validateConstraints([{ conds: restrictions, msg: "One" }], v);
      //   // console.log("FFFFF", restrictions, c);
      //   if (c.length > 0) return;
      // }
      setFetched((p) => ({ ...p, [v.id]: { ...v, skey } }));
    },
    [setFetched]
  );

  const clearFetched = useCallback(() => {
    setFetched({});
    setVers((v) => v + 1);
  }, [setFetched, setVers]);

  return (
    <div sx={{ py: 4 }}>
      <div sx={{ backgroundColor: colorShades.blueShade7, p: 2 }}>
        <EMISearchBox
          key={vers}
          filters={filters}
          advanced={searchModes.includes("advanced") ? advanced : false}
          onlyOne={!bulkOne}
          label={
            searchLabel ||
            (!bulkOne
              ? "Enter Abhyasi ID / Email ID / Mobile Number"
              : "Enter Abhyasi IDs / Email IDs / Mobile Numbers")
          }
          onNewValue={onNewValue}
          isPreceptorSearch={isPreceptorSearch}
        />
        <Stack horizontal horizontalAlign="end">
          {searchModes.includes("advanced") && !advanced && (
            <ActionButton
              iconProps={{ iconName: "WebAppBuilderFragment" }}
              text="advanced search"
              onClick={toggleAdvanced}
            />
          )}
          {searchModes.includes("bulk") && !bulkOne && (
            <ActionButton
              iconProps={{ iconName: "Group" }}
              text="bulk search"
              onClick={toggleOne}
            />
          )}
          {searchModes.includes("basic") && (advanced || bulkOne) && (
            <ActionButton
              iconProps={{ iconName: "Contact" }}
              text="basic search"
              onClick={toggleOne}
            />
          )}
        </Stack>
      </div>
      {Object.keys(fetched).length > 0 && (
        <div sx={{ fontSize: "0.8em", mb: 2 }}>
          <i>Search Results will get appended below.</i>{" "}
          {showClearBtn && (
            <ActionButton text="Clear results!" onClick={clearFetched} />
          )}
        </div>
      )}

      <table width="100%">
        <tbody>
          {Object.values(fetched).map((r) => (
            <tr>
              <td>
                <RenderSearchResult
                  skey={r.skey}
                  record={r}
                  renderSelectBtn={renderSelectBtn}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

AbhyasiEMISearchBox.propTypes = {
  searchModes: PropTypes.arrayOf(PropTypes.oneOf("basic", "bulk", "advanced")),
  renderSelectBtn: PropTypes.func,
  showClearBtn: PropTypes.bool,
  searchLabel: PropTypes.string,
  restrictions: PropTypes.arrayOf(PropTypes.string),
  isPreceptorSearch: PropTypes.bool,
};

AbhyasiEMISearchBox.defaultProps = {
  searchModes: ["basic", "bulk"],
  renderSelectBtn: null,
  showClearBtn: true,
  searchLabel: null,
  restrictions: null,
  isPreceptorSearch: false,
};

export default AbhyasiEMISearchBox;
